"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var ReactTagsField = function ReactTagsField(props) {
  var classes = {
    root: "\n      bl-flex bl-relative bl-flex-col-reverse bl-rounded-sm bl-text-xs\n      bl-leading-tight bl-cursor-text bl-grey-900",
    rootFocused: 'is-focused',
    selected: 'bl-max-w-xl-grid-1 bl-inline',
    selectedTag: "\n      bl-inline-block bl-box-border bl-mr-grid-1 bl-mb-grid-1\n      bl-py-grid-1 bl-px-grid-2 bl-border bl-border-solid\n      bl-border-gray-400 bl-grey-900 bl-rounded-sm bl-bg-grey-100\n      bl-react-tags__selected-tag",
    selectedTagName: 'bl-text-grey-900',
    search: 'bl-inline-block bl-py-grid-1 bl-px-grid-0 bl-mb-grid-1 bl-max-w-full bl-min-w-xl-grid-1',
    searchInput: 'bl-text-grey-900 bl-react-tags__search-input',
    suggestions: 'bl-text-grey-900 bl-absolute bl-top-full bl-w-full bl-left-grid-0 bl-z-10 bl-react-tags__suggestions',
    suggestionActive: 'is-active',
    suggestionDisabled: 'is-disabled'
  };
  return react_1.default.createElement(core_1.ReactTagsField, __assign({
    classNames: classes,
    autoresize: false
  }, props));
};

exports.default = ReactTagsField;